var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.65355 2.62335H2.68038C2.02606 2.62335 1.49463 3.15479 1.49463 3.8091V13.8142C1.49463 14.4685 2.02606 14.9999 2.68038 14.9999H9.65355C10.3079 14.9999 10.8393 14.4685 10.8393 13.8142V3.8091C10.8362 3.15479 10.3048 2.62335 9.65355 2.62335ZM10.0068 13.8111C10.0068 14.0077 9.84708 14.1675 9.65048 14.1675H2.6773C2.4807 14.1675 2.32097 14.0077 2.32097 13.8111V3.8091C2.32097 3.6125 2.4807 3.45276 2.6773 3.45276H9.65048C9.84708 3.45276 10.0068 3.6125 10.0068 3.8091V13.8111Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3201 0H5.34688C4.69257 0 4.16113 0.531436 4.16113 1.18575C4.16113 1.41614 4.34545 1.60045 4.57584 1.60045C4.80623 1.60045 4.99054 1.41614 4.99054 1.18575C4.99054 0.989146 5.15028 0.829408 5.34688 0.829408H12.3201C12.5167 0.829408 12.6764 0.989146 12.6764 1.18575V11.1909C12.6764 11.3875 12.5167 11.5472 12.3201 11.5472C12.0897 11.5472 11.9053 11.7315 11.9053 11.9619C11.9053 12.1923 12.0897 12.3766 12.3201 12.3766C12.9744 12.3766 13.5058 11.8452 13.5058 11.1909V1.18575C13.5058 0.531436 12.9744 0 12.3201 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.941c97b6739cbe1922e76656a6e3ce74.svg";
export { ForwardRef as ReactComponent };